import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService, CLIENT_TYPES } from '../../../authorization/authentication.service';
import { checkClientTypePermission } from '../../base-functions/permission.base-functions';
import { ACToasterService } from '../../services/ac-toaster.service';

@Injectable()
export class Guard_ASSET_TRACKING_P implements CanActivate {

    constructor(
        private serviceAuthentication: AuthenticationService,
        private serviceACToaster: ACToasterService
    ) { }

	/**
	 * Validate if user is in a client with ASSET_TRACKING type
	 * @param route
	 * @param state
	 * @returns {boolean}
	 */
    public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        try {
            const currentUser = this.serviceAuthentication.currentUserValue;
            const result = checkClientTypePermission(currentUser, CLIENT_TYPES.ASSET_TRACKING);
            if(!result) {
                this.serviceACToaster.showPermissionWarning();
            }  

            return result;
        } catch (error) {
            return false;
        }
    }
}
